module.exports = __webpack_public_path__ + "assets/78795b99902f8f385cdbd13b7110c785.png";